import { SimpleEventDispatcher } from 'ste-simple-events';

export const variantPhotoEvents = {
  photoUpdated: new SimpleEventDispatcher<number>(),
};
